﻿
export function shareModalPrivateDisabledState(id, active) {
    var elems = $(".modal-dialog .private-share-disable");
    var userElems = $(".modal-dialog .private-share-user-selected");
    var parsedId = parseInt(id);

    elems.css('visibility', parsedId != 0 && active ? 'visible' : 'hidden');
    userElems.css('visibility', parsedId != 0 ? 'visible' : 'hidden');
    if (parsedId != 0 && active) {
        shareModalTogglePasswordState();
    }
}

export function shareModalDisabledState(shared) {
    var elems = $(".modal-dialog .share-disable");

    elems.css("visibility", shared ? "visible" : "hidden");
    if (shared) {
        shareModalTogglePasswordState();
    }
}

export function shareModalTogglePasswordState() {
    var userPass = $(".modal-dialog #sharing-user-password");
    var pass = $(".modal-dialog #sharing-password");
    var showUserPass = $(".modal-dialog #UserSettings_NeedsPassword").val() === 'True' && $('#UserSettings_ShareActive').val() === 'True';
    var showPass = $(".modal-dialog #NeedsPassword").val() === 'True';

    if (showUserPass) {
        userPass.css('visibility', 'visible');
    } else {
        userPass.css('visibility', 'hidden');
    }
    if (showPass) {
        pass.css('visibility', 'visible');
    } else {
        pass.css('visibility', 'hidden');
    }
}

export function shareModalLiveHiddenState(live) {
    var liveElems = $(".modal-dialog .live-settings");
    //var copyElems = $(".modal-dialog .copy-settings");

    // for now
    //animate = false;

    if (!live || live === "False") {
        liveElems.hide(); 
        //copyElems.show(); 
    } else {
        liveElems.show();  
        //copyElems.hide();
    }
    shareModalPrivateDisabledState($(".modal-dialog select[name='UserSettings.Id']").val(), $('#UserSettings_ShareActive').val() === 'True');
}

// NB! Should create a separate function for: var copyElems = $(".modal-dialog .copy-settings");
// It should work equal to the above 'Live', but completely separate, should hide/unhide Copy sharing: Copy settings if Copy is Not chosen/chosen
  
